import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import ContentLangButton from 'src/components/common/ContentLangBtn';

const mapStateToProps = state => ({
  currentLang: state.massAction.currentCampaignAction
    ? state.massAction.currentCampaignAction.language
    : null,
});

const CtnLangComponent = props => {
  const { t } = useTranslation();
  return <ContentLangButton {...props} title={t('smartmessaging.tooltip.contentLangButton')} />;
};

export default connect(mapStateToProps, {
  onContentLangChange: value => ({ type: 'ON_MASSACTION_CONTENT_LANG_CHANGE', value }),
})(CtnLangComponent);
